<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'FormationsSea'
});
</script>
<template>
  <ka-container
    code="prog-02-sea"
    :data="page.$info.prog02Sea">
    <!-- Page formation - V -->
    <ka-container code="page-formation-v">
      <PFormationEntete
        instance-class="p-formation-entete--p35"
        h-1="Formation en SEA"
        texte="La formation est réalisée par un<strong> expert en SEA</strong> issu d'une entreprise à succès." />
      <!-- Container experts -->
      <ka-container code="container-experts">
        <ka-text code="titre">
          <span v-html="t('prog02Sea.pageFormationV.containerExperts.titre.value', `Nos experts en SEA`)" />
        </ka-text>
        <ka-text code="texte">
          <span v-html="t('prog02Sea.pageFormationV.containerExperts.texte.value', `Notre communauté d'experts regroupe de nombreux profils en SEA. Ces professionnels du marketing digital sont, pour la grande majorité, toujours salariés et mettent en œuvre les techniques de SEA au quotidien. Ils ont une connaissance approfondie de la gestion de campagnes publicitaires et ont décidé de partager leur passion pour cette spécialisation avec des entreprises qui souhaitent rapidement monter en compétence en SEA. Avec eux, vous pourrez lancer vos premières campagnes ou bien tripler la performance des précédentes !`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container">
          <BlocPreviewProfilExpert
            instance-class="bloc-preview-profil-expert--p35"
            :options="{
              href: `https://www.matchers.fr/expert/245`,
              ariaLabel: `bloc preview profil expert`,
              click: page.blocPreviewProfilExpertClick
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.blocPreviewProfilExpertTags"
            poste="Responsable acquisition"
            first-name="Florian"
            enttreprise="&#64;Olympique Lyonnais"
            image="https://ucarecdn.com/50904040-3a1b-4179-a621-29902a0871de/" />
          <BlocPreviewProfilExpert
            instance-class="element-1--p35"
            :options="{
              href: `https://www.matchers.fr/expert/430`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element1Click
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.element1Tags"
            poste="SEA manager"
            first-name="Véra"
            enttreprise="&#64;Voyage Privé"
            image="https://ucarecdn.com/394b21a6-b4d0-45e1-97a8-c05dc0ab8916/" />
          <BlocPreviewProfilExpert
            instance-class="element-2--p35"
            :options="{
              href: `https://www.matchers.fr/expert/482`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element2Click
            }"
            :tags="page.$constants.element2Tags"
            poste="Experte SEO &amp; SEA"
            first-name="Nathalie"
            enttreprise="&#64;Odity"
            image="https://ucarecdn.com/e639757c-89b1-420c-96bc-d9737d8750c6/" />
          <BlocPreviewProfilExpert
            instance-class="element-3--p35"
            :options="{
              href: `https://www.matchers.fr/expert/195`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element3Click
            }"
            :tags="page.$constants.element3Tags"
            poste="User acquisition manager"
            first-name="Olivier"
            enttreprise="&#64;Betclic"
            image="https://ucarecdn.com/dd07b0f8-8d3a-4e86-8f8e-35bc21911cce/" />
        </ka-container>
        <ka-text
          code="voir"
          :options="{
            href: `https://www.matchers.fr/experts`,
            ariaLabel: `voir`,
            click: page.voirClick
          }">
          <span v-html="t('prog02Sea.pageFormationV.containerExperts.voir.value', `Voir plus de profils >`)" />
        </ka-text>
      </ka-container>
      <!-- Container programme -->
      <ka-container code="container-programme">
        <!-- Container gauche -->
        <ka-container code="container-gauche">
          <!-- Container programme de formation -->
          <ka-container code="container-programme-de-formation">
            <!-- Titre exemple de programme -->
            <ka-container code="titre-exemple-de-programme">
              <ka-text code="voici-un-exemple-de">
                <h2 v-html="t('prog02Sea.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.titreExempleDeProgramme.voiciUnExempleDe.value', `Voici un exemple de programme de formation`)" />
              </ka-text>
            </ka-container>
            <!-- Module1 -->
            <ka-container code="module-1">
              <ka-text code="etre-autonome-sur-sa">
                <h2 v-html="t('prog02Sea.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.module1.etreAutonomeSurSa.value', `Être autonome sur sa stratégie de contenu publicitaire`)" />
              </ka-text>
              <!-- Container -->
              <ka-container code="container-1" />
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="sections-deroulantes">
              <!-- Conteneur section -->
              <ka-container code="conteneur-section">
                <DropDownFormation
                  instance-class="drop-down-formation--p35"
                  titre="I.   Choisir les régies médias sociaux en fonction de ses objectifs"
                  :arguments="page.$constants.dropDownFormationArguments" />
              </ka-container>
            </ka-container>
            <!-- Module2 -->
            <ka-container code="module-2">
              <ka-text code="creer-des-campagnes">
                <h2 v-html="t('prog02Sea.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.module2.creerDesCampagnes.value', `Créer des campagnes publicitaires et les rendre performantes`)" />
              </ka-text>
              <!-- Container -->
              <ka-container code="container-2" />
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="container-3">
              <!-- Conteneur section -->
              <ka-container code="container-4">
                <DropDownFormation
                  instance-class="element-4--p35"
                  titre="I.   Créer des campagnes publicitaires en ligne sur Facebook Ads"
                  :arguments="page.$constants.element4Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-5">
                <DropDownFormation
                  instance-class="element-5--p35"
                  titre="II.   Créer des campagnes publicitaires en ligne sur Google Ads"
                  :arguments="page.$constants.element5Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-6">
                <DropDownFormation
                  instance-class="element-6--p35"
                  titre="III.   Savoir analyser les performances de son trafic : de l’acquisition à la conversion"
                  :arguments="page.$constants.element6Arguments" />
              </ka-container>
            </ka-container>
          </ka-container>
          <CtaProgrammeSurMesurePrendreRdv instance-class="cta-programme-sur-mesure-prendre-rdv--p35" />
        </ka-container>
        <BlocArgCtaRdvPedagogieMatchers
          instance-class="bloc-arg-cta-rdv-pedagogie-matchers--p35"
          :xs="{ hidden: null }"
          expert-1="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
      </ka-container>
      <BlocArgPasDeFraisPasDeDemarchesAdministratives instance-class="bloc-arg-pas-de-frais-pas-de-demarches-admi--p35" />
      <PFormationMatching
        instance-class="p-formation-matching--p35"
        description-company="<strong>Sportydeal</strong> | Plateforme de revente de matériel de sport outdoor d'occasion.<br> <br><strong>Besoin : </strong>Générer du trafic et acquérir des prospects. "
        expert-text="<strong>Cyril </strong>| Traffic Manager | &#64;Neocamino.<br> <br> <br><strong>Expertise : </strong>Expert spécialisé dans le suivi et l'analyse des résultats publicitaires des sites Internet."
        budget-available="840€"
        training-hours="7h"
        support-duration="d’accompagnement à raison de 2h de formation par semaine."
        photo-expert="https://ucarecdn.com/6ac4bfa5-670c-475d-8188-528343a79512/"
        image="https://ucarecdn.com/5310d9bf-743f-4faa-8229-a0b3e4e0e849/" />
      <BlocReassuranceQualiopi instance-class="bloc-reassurance-qualiopi--p35" />
      <PFormationCriteresQualiopi instance-class="p-formation-criteres-qualiopi--p35" />
      <PFormationPourquoiSeFormer
        instance-class="p-formation-pourquoi-se-former--p35"
        text="<strong>Pourquoi se former en SEA avec Matchers ?</strong>"
        text-1="Notre formation en SEA (Search Engine Advertising) vous permet de <strong>sponsoriser votre site</strong> pour qu'il apparaisse dans les premiers résultats d'une recherche. Accompagné par un expert, vous découvrirez toutes les étapes de toutes les manipulations pas à pas. <br> <br>Si vous n’êtes plus novice sur le sujet, nous pourrons également vous mettre en relation avec un expert en SEA pour vous accompagner sur des <strong>enjeux plus stratégiques</strong> qu’opérationnels. <br> <br>Tout comme le SEO, le SEA permet d’améliorer la visibilité en ligne de votre entreprise. Il s’agit d’une stratégie coûteuse mais qui peut rapidement offrir un retour sur investissement !"
        image="https://ucarecdn.com/48846a9b-7e7d-4139-adc5-5bd1ff4cfacd/" />
    </ka-container>
    <!-- Sections du domaine -->
    <ka-container code="sections-du-domaine">
      <PFormationSectionBleu
        instance-class="p-formation-section-bleu--p35"
        paragraph="Faire une formation en SEA vous permet de <strong>cibler avec précision</strong> les utilisateurs qui recherchent des produits ou services similaires à ceux proposés par votre entreprise.<br> <br>Et oui ! En choisissant les bons mots clés pour mettre en avant votre site, les prospects qui s’y rendent ont donc déjà <strong>manifesté leur intérêt </strong>pour ce que vous avez à leur proposer. L’audience est donc justement ciblée et qualitative puisque vos annonces sont mises en avant auprès d’internautes ayant fait une recherche en cohérence avec votre contenu.<br> <br>Pour un <strong>ciblage ultra précis</strong>, vous pourrez également apprendre à cibler en fonction de la géolocalisation, de l'heure…etc."
        title="Vous souhaitez atteindre une cible précise ?"
        picture="https://ucarecdn.com/342e40be-53f7-44a9-b444-735374b680fd/" />
      <PFormationSectionBanche
        instance-class="p-formation-section-banche--p35"
        paragraph="Le SEA offre un contrôle sur le ciblage et le contenu de votre annonce, mais aussi sur le <strong>budget</strong> !<br> <br>En effet, les dépenses en SEA sont <strong>limitées et contrôlables</strong> puisque le coût par clic dépend de la concurrence des autres entreprises annonceurs ! Le budget s’évalue donc en fonction de la popularité des mots-clés que vous souhaitez utiliser.<br> <br>Vous former en SEA vous permet de comprendre ces informations pour pouvoir <strong>ajuster votre campagne publicitaire en temps réel</strong>, en fonction des résultats et des tendances actuelles !"
        title="Vous devez garder un oeil sur votre budget ?"
        picture="https://ucarecdn.com/6af1630c-6e7f-4562-88c1-6be7b0b84103/"
        seo-image="Une formation en SEO avec Matchers " />
      <PFormationSectionBleu
        instance-class="element-7--p35"
        paragraph="À l’issue d’une formation en SEA avec Matchers, vous serez capable de faire vos campagnes en toute <strong>autonomie</strong>.<br> <br>Particulièrement utile pour les entreprises qui lancent une <strong>nouvelle offre</strong> ou qui ont besoin d'une réponse rapide à leur <strong>campagne marketing</strong> !"
        title="Une stratégie sur le long terme pour un résultat immédiat"
        picture="https://ucarecdn.com/3e92fb13-8a35-4253-b785-9a2f2a681f1c/" />
      <PFormationSectionBanche
        instance-class="element-8--p35"
        paragraph="Notre expert en SEA vous accompagne pour <strong>comprendre et mesurer </strong>les résultats de votre campagne sponsorisée (nombre de clics, taux de conversion…)."
        title="Vous souhaitez mesurer votre ROI ?"
        picture="https://ucarecdn.com/7280f406-193c-47c9-b6dc-3f6bd2508a8c/" />
      <PFormationSectionBleu
        instance-class="element-9--p35"
        paragraph="Grâce à l’accompagnement sur-mesure de l’un de nos experts en SEA, vous pouvez<strong> tester plusieurs stratégies </strong>publicitaires, créer des annonces personnalisées pour différents publics et cibler diverses étapes du parcours du prospect. <br> <br>Vous former avec les conseils d’un expert du métier vous aidera à trouver la <strong>stratégie publicitaire la plus efficace </strong>pour votre entreprise !"
        title="Vous n’êtes pas satisfait de votre stratégie ?"
        picture="https://ucarecdn.com/16cb5c30-99e3-4e05-8dd8-6372aad6ba01/" />
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { formationsSea } from './store'
import BlocArgCtaRdvPedagogieMatchers from '~/components/BlocArgCtaRdvPedagogieMatchers/index.vue'
import BlocArgPasDeFraisPasDeDemarchesAdministratives from '~/components/BlocArgPasDeFrais/PasDeDemarchesAdministratives/index.vue'
import BlocPreviewProfilExpert from '~/components/BlocPreviewProfilExpert/index.vue'
import BlocReassuranceQualiopi from '~/components/BlocReassuranceQualiopi/index.vue'
import CtaProgrammeSurMesurePrendreRdv from '~/components/CtaProgrammeSurMesurePrendreRdv/index.vue'
import DropDownFormation from '~/components/DropDownFormation/index.vue'
import PFormationCriteresQualiopi from '~/components/PFormationCriteresQualiopi/index.vue'
import PFormationEntete from '~/components/PFormationEntete/index.vue'
import PFormationMatching from '~/components/PFormationMatching/index.vue'
import PFormationPourquoiSeFormer from '~/components/PFormationPourquoiSeFormer/index.vue'
import PFormationSectionBanche from '~/components/PFormationSectionBanche/index.vue'
import PFormationSectionBleu from '~/components/PFormationSectionBleu/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p35')
const appData = appDataStore()
const page = formationsSea()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
